module.exports = __webpack_public_path__ + "html/user-info.component.html";